import React, { useState, useEffect, FC } from 'react'
import { formatPublicPropertyAddress } from 'utils/formatting'
import Header from 'components/MarketingSite/Header'
import Footer from 'components/MarketingSite/Footer'
import AddressAutocomplete from 'components/MarketingSite/Header/AddressAutocomplete'
import Card from 'components/Card'

import styles from './styles.module.scss'

interface UnavailableProps {
  address: string
  suggestions?: {
    attom_id: string
    propertyaddressfull: string
    propertyaddresscity: string
    propertyaddressstate: string
    propertyaddresszip: string
    public_property_path: string
  }[]
}

const Unavailable: FC<UnavailableProps> = ({ address, suggestions }) => {
  const [campaignId, setCampaignId] = useState<string>()

  useEffect(() => {
    if (!campaignId) {
      const searchParams = new URLSearchParams(window.location.search)
      if (searchParams.has('mc')) {
        // If this was a marketing campaign, grab the campaign
        const newCampaignId = searchParams.get('mc') as string
        setCampaignId(newCampaignId)
      }
    }
  }, [campaignId])

  return (
    <div className={styles.unavailable}>
      <Header campaignId={campaignId}>
        <AddressAutocomplete
          placeholder={['Enter an address to view another property', 'Enter an address']}
          positionLabel="header"
        />
      </Header>
      <div className={styles.wrapper}>
        <Card className={styles.card}>
          <h1>{address}</h1>
          <h2>{'This property is not covered.... yet!'}</h2>
          {(suggestions?.length || 0) > 0 && (
            <section className={styles.didYouMeanSection}>
              <h3>{'Did you mean?'}</h3>
              <div>
                {suggestions?.map((suggestion) => {
                  let linkPath = `/onboarding?attom_id=${suggestion.attom_id}`
                  // If they're here as part of a marketing campaign, we need to send them
                  // to sign_up with these links.
                  if (campaignId) {
                    linkPath = `/onboarding?attom_id=${suggestion.attom_id}&mc=${campaignId}`
                  }
                  return (
                    <div className={styles.suggestion} key={suggestion.attom_id}>
                      <a href={linkPath}>{formatPublicPropertyAddress(suggestion as any)}</a>
                    </div>
                  )
                })}
              </div>
            </section>
          )}
          <p>
            {'Realm offers coverage of detached single family homes in '}
            <a
              href="/resources/library/realm-now-available-for-80m-single-family-homes/"
              target="_blank"
              rel="noopener noreferrer"
            >
              {'certain geographies'}
            </a>
            {
              '. We are actively adding new geographies each week and plan to expand to multi-family homes and condos later this year.'
            }
          </p>
        </Card>
        <Footer />
      </div>
    </div>
  )
}

export default Unavailable
